<script>
import Layout from "../../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { organizationMethods } from "@/state/helpers";

/**
 * Sales-Dashboard component
 */
export default {
  page: {
    title: "Sales Dashboard",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  methods: {
    ...organizationMethods,
    testCreateOrganization(){
      console.log(this.sampleData);
      this.createOrganization(this.sampleData);
    }
  },
  data() {
    return {
      sampleData: {
          "businessType": null,
          "logo": null,
          "name": "Test",
          "contact_number": null,
          "street": "asdas",
          "barangayId": 15505007,
          "cityId": 15505,
          "provinceId": 155,
          "province": "PANGASINAN",
          "city": "ANDA",
          "barangay": "Dolaoan"
      },
      title: "Sales Analytics",
      items: [
        {
          text: "Dashonic",
        },
        {
          text: "Sales Analytics",
          active: true,
        },
      ],
    };
  },
  components: {
    Layout,
    PageHeader,
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-button variant="primary" @click="testCreateOrganization">Button</b-button>
  </Layout>
</template>
